// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"923":"d1f8c93906ed2d277412","944":"c951a3f1d1c81e35c471"}[chunkId] + ".js";
};